import { useCallback } from "react";
import { useNotify } from "react-admin";

type ApiError = {
  body?: {
    errors?: Array<{
      message?: string;
    }>;
  };
  message?: string;
};

type ErrorContext = Record<string, unknown>;

const isApiError = (error: unknown): error is ApiError => typeof error === "object" && error !== null;

// TODO: This error handling pattern should be unified across the entire app
// This implementation is influenced by the example in OrganizationCreate component
// Consider expanding this utility when refactoring error handling throughout the application
export const useErrorHandler = () => {
  const notify = useNotify();

  const handleError = useCallback(
    (error: unknown, defaultMessage: string, context?: ErrorContext) => {
      console.error("Error:", error, context);

      // Try to extract a meaningful message from the error
      let errorMessage = defaultMessage;

      if (isApiError(error) && error.body?.errors?.length && error.body.errors.length > 0) {
        errorMessage = `${errorMessage}: ${error.body.errors[0].message}`;
      } else if (isApiError(error) && error.message) {
        errorMessage = `${errorMessage}: ${error.message}`;
      }

      notify(errorMessage, { type: "error", autoHideDuration: 5000 });
    },
    [notify]
  );

  return handleError;
};
